package com.jingfangpai.common.data.type

import com.jingfangpai.common.data.serializer.BigDecimalSerializer
import kotlinx.serialization.Serializable

@Serializable(with = BigDecimalSerializer::class)
expect class BigDecimal(strVal: String) {
    constructor(doubleVal: Double)
    constructor(intVal: Int)
    constructor(longVal: Long)
    fun add(augend: BigDecimal): BigDecimal
    fun subtract(subtrahend: BigDecimal): BigDecimal
    fun multiply(multiplicand: BigDecimal): BigDecimal
    fun divide(divisor: BigDecimal): BigDecimal
    fun remainder(divisor: BigDecimal): BigDecimal
    fun negate(): BigDecimal
    fun compareTo(other: BigDecimal): Int
    fun toFixed(scale:Int):BigDecimal
    fun toByte(): Byte
    fun toChar(): Char
    fun toDouble(): Double
    fun toFloat(): Float
    fun toInt(): Int
    fun toLong(): Long
    fun toShort(): Short
    override fun toString():String
}

val ZERO = BigDecimal(0)
val ONE = BigDecimal(1)
val TEN = BigDecimal(10)
val NEGATIVE_ONE = BigDecimal(-1)

operator fun BigDecimal.plus(augend: BigDecimal) = this.add(augend)
operator fun BigDecimal.minus(subtrahend: BigDecimal) = this.subtract(subtrahend)
operator fun BigDecimal.times(multiplicand: BigDecimal) = this.multiply(multiplicand)
operator fun BigDecimal.div(divisor: BigDecimal) = this.divide(divisor)
operator fun BigDecimal.rem(divisor: BigDecimal) = this.remainder(divisor)
operator fun BigDecimal.unaryMinus() = this.negate()
operator fun BigDecimal.inc() = this.add(ONE)
operator fun BigDecimal.dec() = this.subtract(ONE)

infix fun BigDecimal.eq(other: BigDecimal) = this.compareTo(other) == 0
infix fun BigDecimal.neq(other: BigDecimal) = this.compareTo(other) != 0
